<div id="mission_activities">
    @if(this.missionsItems && this.missionsItems.length > 0){
        @for(missionItem of this.missionsItems; track $index){
            <app-mission-item-history [mission]="missionItem" [displayOperation]="false" (onSelectMission)="this.onSelectMission($event)"/>
        }
    }
    @else{
        <marv-message type="info">{{'MSG_NO_MISSION' | translate}}</marv-message>
    }
</div>

<marv-section-title label="{{'PICTURES' | translate}}" icon="images-outline"/>

<app-photo-gallery-list [mission]="this.photoGalleryMission" defaultView="mozaic" [showViews]="false" [showSizes]="false" [showFilters]="false" [savingFilters]="false"/>